import { translateContent } from '~src/services/translationServices';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';
import { getUserFullName } from '~src/interfaces/user.interface';
import { OwnerI } from '~src/store/okrs/interfaces';

const getNames = (segment: Segment) => {
  let [firstname, lastname, email] = ['UNKNOWN', 'UNKNOWN', 'UNKNOWN'];
  switch (segment.type) {
    case SegmentType.User:
      firstname = segment.meta.firstname;
      lastname = segment.meta.lastname;
      email = segment.meta.email;
      break;
    case SegmentType.Company:
      firstname = segment.meta.name;
      break;
    case SegmentType.Group:
      firstname = translateContent(segment.meta.option_name);
      break;
    case SegmentType.Team:
      firstname = segment.meta.manager_name;
  }
  return { firstname, lastname, email };
};

export const segmentToOwner = (segment: Segment): OwnerI => ({
  uuid: segment.id,
  imageUrl: segment.image_url,
  ...getNames(segment),
});

export const ownerToSegment = (owner: OwnerI): Segment => ({
  id: owner.uuid,
  image_url: owner.imageUrl || '',
  // name: getUserFullName(owner), // TODO unused?
  meta: {
    email: owner.email,
    firstname: owner.firstname,
    lastname: owner.lastname,
    name: getUserFullName(owner),
    manager_uuid: null,
  },
  type: SegmentType.User,
});

export const keyresultProgressableToDecimal = (value: any): number => {
  return Math.round(value) / 100;
};

export const formatKeyresultProgressable = (value: number): string =>
  (value / 100) % 1 === 0 ? Math.round(value / 100).toString() : (value / 100).toFixed(2);

export const keyresultDecimalToProgressable = (value: string | number) =>
  typeof value === 'string' ? Math.round(parseFloat(value) * 100) : Math.round(value * 100);
